import React from 'react';
import classnames from 'classnames';

import { IDocViewIFrameProps } from './DocumentViewer';

const MSDocIframe: React.FC<IDocViewIFrameProps> = ({ fileURL, onError }) => {
  // tslint:disable-next-line: max-line-length
  const embedURL = `https://view.officeapps.live.com/op/embed.aspx?src=${fileURL}`;

  return (
    <div className={classnames('doc-viewer__content__iframe')}>
      <iframe onError={onError} src={embedURL} width="100%" height="100%" />
    </div>
  );
};

export default MSDocIframe;
